import { Injectable, OnDestroy, inject } from '@angular/core';
import { Messaging, deleteToken, getToken } from '@angular/fire/messaging';
import { SwPush } from '@angular/service-worker';

import { Observable, from, switchMap } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { SERVER_VAPID_KEY } from '@env/constrant/environment.constrant';

import { PushNotificationsPlatformService } from '@core/services/push-notifications/platforms/push-notifications-platform.service';
import { PushPlatformService } from '@core/services/push-notifications/platforms/push-platform.service';
import { PushNotificationsPwaUrlStore } from '@core/services/push-notifications/push-notifications-pwa-url.store';
import { PushNotificationPlatformType } from '@core/services/push-notifications/push-notifications.types';

@Injectable()
export class PushNotificationsPlatformWebFcmService extends PushNotificationsPlatformService implements OnDestroy {
  platform: PushNotificationPlatformType = 'web';

  private messaging: Messaging = inject(Messaging);
  private swPush: SwPush = inject(SwPush);
  private store = new PushNotificationsPwaUrlStore();

  constructor() {
    super();
  }

  addListeners() {
    this.isAvailable().then((value) => {
      if (value) {
        navigator.serviceWorker.addEventListener('message', (event) => {
          console.log(event);
          if (event.data.type === 'PUSH_RECEIVED') {
            console.log();
            this.notificationReceived$.next(event.data.payload.notification);
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.isAvailable().then((value) => {
      if (value) {
        navigator.serviceWorker?.removeEventListener('message', () => {});
      }
    });
  }

  isAvailable(): Promise<boolean> {
    const swPushEnabled = this.swPush?.isEnabled;
    const fcmAvailable = !!this.messaging;
    const pushInfo = PushPlatformService.getInfo();
    return Promise.resolve(swPushEnabled && fcmAvailable && pushInfo.canRequestPush);
  }

  override registration(): Observable<string | null> {
    const vapidKey = SERVER_VAPID_KEY;

    return from(navigator.serviceWorker.ready).pipe(
      switchMap((serviceWorkerRegistration) => {
        return getToken(this.messaging, { vapidKey, serviceWorkerRegistration });
      }),
      tap(() => this.addListeners())
    );
  }

  override checkPermission(): Observable<boolean> {
    return from(navigator.permissions.query({ name: 'notifications' })).pipe(
      map((permStatus) => permStatus.state === 'granted')
    );
  }

  override unregister() {
    return from(deleteToken(this.messaging));
  }

  override goToSettings() {
    throw new Error('Method not implemented');
  }

  override generateKey(): Observable<string> {
    throw new Error('Method not implemented');
  }

  override setUrl(url: string) {
    this.store.saveUrl(url);
  }
}
